module.exports = __webpack_public_path__ + "static/media/timer-lose.c6dbf07f.png";